import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { apiGetDietitian } from "Root/api/apiProfile";
import matt_png from "Images/profile/matt.png";
import mary_png from "Images/profile/mary_img.png";
import ChatPhone from "Images/profile/chat_phone.png";
import AccountBanner from "../AccountBanner";
import styles from "./style.module.scss";
const AccountRDSection = ({ customText }) => {
    const [myRD, setMyRD] = useState({
        assigned_RD: "",
        has_contacted_RD: false,
        macroAnswers: null,
        macroResult: null,
    });
    const history = useHistory();
    const fetchRDData = async () => {
        const data = await apiGetDietitian();
        setMyRD(data);
    };
    useEffect(() => {
        fetchRDData();
    }, []);
    const goToRDPage = () => history.push("/app/dietitian");
    return (_jsx(AccountBanner, { imgUrl: ChatPhone, titleImage: myRD.assigned_RD.toLowerCase() === "matt" ? matt_png : mary_png, title: `Connect with  ${myRD.assigned_RD}`, subtitle: "Your personal registered dietitian", text: customText ||
            `Enjoy unlimited access from your Registered Dietitian, ${myRD.assigned_RD}, who is here to help you along your fitness journey.`, showButton: true, onClick: goToRDPage, btnText: `Chat With ${myRD.assigned_RD}`, bannerWrapperClassName: styles.rd_section }));
};
export default AccountRDSection;
